import URLS from '@/server/urls';
import { POST } from '@/server/http';

export default async ({
    ids = [],
}, options = { showError: true }) => {
    const [ content, error, status ] = await POST(URLS.kpi.myProjKpi.removeSubmitProjKpi, {
        ids,
    }, options);
    if (error) return { error, status };
    return content || { };
};
